import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useToast = defineStore('toast', () => {
    const toasts = ref([])

    const show = (options, duration = 4000) => {
        const id = Date.now() + Math.random()
        
        // Handle both old string format and new object format
        let toast
        if (typeof options === 'string') {
            toast = { 
                id, 
                message: options, 
                type: 'success', 
                duration,
                title: null,
                color: null,
                icon: null
            }
        } else {
            toast = { 
                id, 
                title: options.title || null,
                message: options.message || '',
                type: options.type || 'success',
                color: options.color || null,
                icon: options.icon || null,
                duration: options.duration || duration
            }
        }
        
        toasts.value.push(toast)
        
        setTimeout(() => {
            remove(id)
        }, toast.duration)
        
        return id
    }
    
    const remove = (id) => {
        const index = toasts.value.findIndex(t => t.id === id)
        if (index > -1) {
            toasts.value.splice(index, 1)
        }
    }
    
    const success = (message, duration) => show({ message, type: 'success' }, duration)
    const error = (message, duration) => show({ message, type: 'error' }, duration)
    
    return {
        toasts,
        show,
        remove,
        success,
        error
    }
})